"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
import textStyles from "../../../theme/foundations/generated/textStyles";
const TextualStepper = ({ children }) => (_jsx(Box, Object.assign({ sx: Object.assign({ px: "2", py: "1", background: "semantic.illustration.background4", display: "flex", w: "fit-content", color: "semantic.text.primary" }, textStyles.body.mediumBold) }, { children: children })));
TextualStepper.displayName = "Stepper";
export default TextualStepper;
//# sourceMappingURL=TextualStepper.js.map